export default function checkIfFullyPaid(userSignupItems) {
  // if the user hasn't paid the full amount yet, show the pay now button
  let userFullyPaid = true;
  Object.keys(userSignupItems).forEach((key) => {
    if (!userFullyPaid) return;

    let userSignupItem = userSignupItems[key];
    if (userSignupItem.respondents.length === 0) return;

    const fullyPaid = userSignupItem.respondents.every(
      (r) => r?.paymentStatus === "Paid" || r?.paymentStatus === "MarkedAsPaid"
    );
    if (fullyPaid) return;

    userFullyPaid = false;
  });

  return userFullyPaid;
}
